/**
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import type { MutationsObject } from '@kp/js-model';
import { BaseCollection } from './BaseCollection';

export class Kanton extends BaseModel {
    id: number | null = null
    kuerzel: string | null = null
    kurz: string | null = null
    lang: string | null = null
    icon: string | null = null

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'kanton';
    }
}

export class KantonCollection extends BaseCollection<Kanton> {
    protected modelCls = Kanton;

    public getModelClassName(): string {
        return 'kanton';
    }
}
